import "core-js/modules/es.object.to-string";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getShopMonthStatCounters } from '@/api/bairun/financialCenter';
import { mapGetters } from 'vuex';
import dateUtils from '@/utils/dateUtil';
import moment from 'moment';
export default {
  name: 'StationDaily',
  data: function data() {
    return {
      data: {},
      datePickerValue: [(dateUtils.todayTimestamp() - 7 * 24 * 60 * 60) * 1000, (dateUtils.todayTimestamp() - 24 * 60 * 60) * 1000],
      sheetUnLoadCount: 1,
      downloadLoading: false,
      shopMonthTotalData: [],
      excelSheets: [{
        tableId: 'shopMonthTotalData',
        name: '便利店月销售汇总',
        tableRows: 1
      }],
      pickerOptionsStart: {
        disabledDate: function disabledDate(pTime) {
          return pTime.getTime() < new Date('2021-12-31').getTime() || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo'])),
  watch: {
    datePickerValue: function datePickerValue() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['shopMonthTotalData'].doLayout(); // console.log('refsUpdate')

      }); // this.loadData()
    }
  },
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs['shopMonthTotalData'].doLayout(); // console.log('refsUpdate')

    }); // this.loadData()
  },
  updated: function updated() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$refs['shopMonthTotalData'].doLayout(); // console.log('refsUpdate')

    });
  },
  methods: {
    loadData: function loadData() {
      var _this4 = this;

      if (this.downloadLoading) {
        return;
      }

      this.downloadLoading = true;
      getShopMonthStatCounters({
        startDate: moment(this.datePickerValue[0]).format('YYYYMMDD'),
        endDate: moment(this.datePickerValue[1]).format('YYYYMMDD')
      }).then(function (response) {
        // console.log('getShopMonthCounters', response)
        _this4.shopMonthTotalData = response.data;
        _this4.sheetUnLoadCount = 0;
        _this4.downloadLoading = false;
      }).catch(function () {
        _this4.downloadLoading = false;
      });
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this5 = this;

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.sheetUnLoadCount > 0) {
        _Message({
          message: '请查询核对过后进行下载',
          type: 'error',
          duration: 5 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, moment(_this5.datePickerValue[0]).format('YYYY年MM月DD日') + '~' + moment(_this5.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this5.downloadLoading = false;
      }).catch(function () {
        _this5.downloadLoading = false;
      });
    }
  }
};